var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: `fill-current text-${_vm.color}`,
    attrs: {
      "height": `${_vm.height}px`,
      "width": `${_vm.width}px`,
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM13.5054 16.4975H10.5044V10.4975H13.5054V16.4975ZM13.501 7.49752C13.501 8.32595 12.8292 8.99752 12.0005 8.99752C11.1718 8.99752 10.5 8.32595 10.5 7.49752C10.5 6.66909 11.1718 5.99752 12.0005 5.99752C12.8292 5.99752 13.501 6.66909 13.501 7.49752Z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }